import { ComponentType, ReactNode, SVGProps } from 'react';

import { cn } from '@/lib/utils';

interface NoticePillProps {
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  children: ReactNode;
}

export default function NoticePill({ icon: Icon, children }: NoticePillProps) {
  return (
    <span
      className={cn(
        'flex items-center gap-2 rounded-2xl bg-black/60 px-3 py-1',
        'paragraph-3 text-white shadow-lg animate-fade-in',
      )}>
      <Icon aria-hidden="true" className="size-4 shrink-0" />
      {children}
    </span>
  );
}
